import React from 'react';

export const GenericCompleteMessage = () => (
  <strong>Your order will now be fulfilled and shipped, straight from one of our partners to you!</strong>
);
